import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Share = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M10.025 9c-.551 0-1.022-.448-1.022-1V6.414L4.417 11l4.586 4.586V14a1 1 0 01.868-.991 15.064 15.064 0 011.975-.133c3.577 0 6.204 1.331 7.858 2.55C18.14 9.201 10.936 9 10.025 9z",
    key: "k0"
  }), React.createElement("path", {
    d: "M11.003 7.054V4a1 1 0 00-1.707-.707l-7 7a.999.999 0 000 1.414l7 7A.999.999 0 0011.003 18v-3.096c.284-.02.565-.029.843-.029 5.426 0 8.239 3.572 8.362 3.73a.996.996 0 001.113.343 1 1 0 00.682-.948c0-9.124-8.086-10.681-11-10.946zm.843 5.821c-.647 0-1.312.045-1.975.133a1.001 1.001 0 00-.868.992v1.586L4.417 11l4.586-4.586V8c0 .552.471 1 1.022 1 .91 0 8.114.201 9.679 6.425-1.654-1.218-4.281-2.55-7.858-2.55z",
    key: "k1"
  }));
});
Share.displayName = 'Share';
export var ShareDimensions = {
  height: 24,
  width: 24
};